/* MAGIJOUETS – "add to cart here" for every form[data-mj-add] and the toast window.mjToast (snippets/mj-cart).
   v17 (2026-10-10, speed): moved from the inline <script> of snippets/mj-cart.liquid, which now loads this file with defer at
   the same place. The browser and Shopify's CDN keep it in cache, so it is no longer downloaded again inside every page.
   Asset files cannot hold Liquid.
   v17 (2026-10-11, tester fixes): the threshold for pages without the product section comes from the toast's
   data-free-from (snippets/mj-cart); the amount in the delivery line is written "394 DH" like the owner's texts.
   v17 home (2026-10-13): the card button's states: .is-busy (+ aria-busy, "Ajout…" with a small spinner, no second
   submit), .is-done for 1.6 s ("Ajouté ✓") and, new, .is-err for 2.4 s ("Non ajouté") when Shopify refuses the add
   (the toast keeps Shopify's own message). The button's accessible name (aria-label) never changes; the toast
   (role=status) announces the result.
   fix r1: the success toast closes after 3.5 s (was 4.2 s) or after an 80 px scroll, unless the focus is in it.
   v24 (2026-10-17): error toasts carry a "Réessayer" button (same add again; not for a stock refusal), a network failure
   shows a French message instead of posting the page, and Horizon's own refusals get the same toast.
   v25 (2026-10-18): after a confirmed add the cart drawer is refreshed (Horizon's section renderer, section
   cart-drawer-section) and opened; the toast is only the fallback (no drawer on /cart, or the refresh failed; the add is
   never sent again). "Choisir les options" ([data-mj-qs], snippets/mj-qa) opens an accessible options window
   (native <dialog>, product data from /products/<handle>.js on the locale's root) before adding.
   v18 (2026-10-14): the card's hover photo (snippets/mj-card) waits behind a 1 px <source data-mj-hold> until a mouse
   first rests on the card; removing the source loads it, and .is-alt on the well lets it fade in once it has arrived. */
(function () {
  if (window.__mjCart) return; window.__mjCart = true;
  // v17: the shop's values come from the toast's data attributes (snippets/mj-cart), as the inline script had them
  var CFG = document.querySelector('[data-mj-toast]'), cfg = function (n, d) { var v = CFG && CFG.getAttribute(n); return v === null || v === undefined ? d : v; };
  var ADD = cfg('data-add-url', '/cart/add.js'), CART = cfg('data-cart-url', '/cart.js');
  // Shopify writes its refusal (e.g. not enough stock) in the store's language: shown only when the page is in
  // French, else our own French sentence. Never the generic "Cart Error".
  var LOCALE = cfg('data-locale', ''), MONEY = cfg('data-money', '');
  // v17 prices in the shop's own money format (as in the header's suggestions; whole amounts without decimals)
  function moneyFmt() { var dflt = '{' + '{amount}' + '}', t = document.createElement('template'); t.innerHTML = String(MONEY || dflt); return (t.content.textContent || '').trim() || dflt; }
  var MF = moneyFmt();
  function money(c) {
    c = Math.round(Number(c) || 0);
    var m = MF.match(/\{\{\s*(\w+)\s*\}\}/), kind = m ? m[1] : 'amount', whole = c % 100 === 0;
    function d(prec, th, dec) { var p = (c / 100).toFixed(prec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = d(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(0, '.', ','); break;
      case 'amount_with_space_separator': v = d(whole ? 0 : 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = d(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = d(whole ? 0 : 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = d(whole ? 0 : 2, ' ', '.'); break;
      default: v = d(whole ? 0 : 2, ',', '.');
    }
    return MF.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.mjMoney = window.mjMoney || money;
  // v17 free delivery from the product section's free_from (cents in data-mj-free-from), else the toast's
  // data-free-from (snippets/mj-cart), else 499 DH; 0 = no line
  function freeFrom() {
    var el = document.querySelector('[data-mj-free-from]'), n = el ? Number(el.getAttribute('data-mj-free-from')) : NaN;
    if (isNaN(n)) n = Number(cfg('data-free-from', 'x'));
    return isNaN(n) ? 49900 : n;
  }
  function shipLine(total) {
    var el = toast && toast.querySelector('[data-mj-toast-ship]'), rule = freeFrom();
    if (!el) return;
    if (typeof total !== 'number' || !(rule > 0)) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = total >= rule ? 'Livraison offerte pour cette commande' : 'Plus que ' + money(rule - total).toUpperCase() + ' pour la livraison offerte';
    el.hidden = false;
  }
  function refusal(j, status) {
    var d = j && typeof j.description === 'string' ? j.description.replace(/\s+/g, ' ').trim() : '';
    if (/^fr\b/i.test(LOCALE || '') && d && !/^cart error$/i.test(d)) return d;
    if (status === 422) return 'Ce jouet n’a pas pu être ajouté au panier : la quantité demandée n’est plus disponible.';
    return 'Ce jouet n’a pas pu être ajouté. Réessayez dans un instant.';
  }
  window.mjCartRefusal = refusal;
  var toast = document.querySelector('[data-mj-toast]');
  if (toast && toast.parentElement !== document.body) document.body.appendChild(toast);
  var tT = null, adds = 0, sy = 0, retryFn = null;
  function hide() { if (toast) toast.classList.remove('is-in'); }
  // v24 (2026-10-17): an error toast can carry a "Réessayer" button (retry = a function that sends the same add again)
  function say(ok, title, text, img, retry) {
    if (!toast) return;
    retryFn = !ok && typeof retry === 'function' ? retry : null;
    var rb = toast.querySelector('[data-mj-toast-retry]'); if (rb) rb.hidden = !retryFn;
    toast.classList.toggle('is-err', !ok);
    toast.querySelector('[data-mj-toast-t]').textContent = title;
    var s = toast.querySelector('[data-mj-toast-s]'); s.textContent = text || ''; s.hidden = !text;
    var sl = toast.querySelector('[data-mj-toast-ship]'); if (sl) { sl.hidden = true; sl.textContent = ''; }
    toast.removeAttribute('data-mj-add-n');
    var box = toast.querySelector('[data-mj-toast-img]'); box.innerHTML = ''; box.hidden = !(ok && img);
    if (ok && img) {
      var c = document.createElement('img');
      c.src = img.currentSrc || img.src; c.alt = ''; c.width = 50; c.height = 50;
      if (img.classList && img.classList.contains('is-photo')) c.className = 'is-photo';
      box.appendChild(c);
    }
    // re-announce the same message: clear the live region first
    toast.classList.remove('is-in'); void toast.offsetWidth; toast.classList.add('is-in');
    clearTimeout(tT); tT = setTimeout(hide, ok ? 3500 : 6000);
    sy = window.scrollY;
  }
  window.mjToast = say;
  if (toast) {
    toast.addEventListener('mouseenter', function () { clearTimeout(tT); });
    toast.addEventListener('mouseleave', function () { clearTimeout(tT); tT = setTimeout(hide, 2000); });
    toast.addEventListener('focusin', function () { clearTimeout(tT); });
    toast.querySelector('[data-mj-toast-x]').addEventListener('click', function () { clearTimeout(tT); hide(); });
    var rbtn = toast.querySelector('[data-mj-toast-retry]');
    if (rbtn) rbtn.addEventListener('click', function () { var f = retryFn; retryFn = null; clearTimeout(tT); hide(); if (f) f(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toast.classList.contains('is-in')) hide(); });
    // fix r1: a scroll of 80 px or more closes a shown toast (not while the focus is in it), so it never covers the next buttons
    window.addEventListener('scroll', function () { if (toast.classList.contains('is-in') && !toast.contains(document.activeElement) && Math.abs(window.scrollY - sy) >= 80) { clearTimeout(tT); hide(); } }, { passive: true });
  }

  // fix (2026-10-16): Horizon's product cards (cart page "Vous aimerez aussi", search) have no error line of their
  // own; their refusals arrive as 'shopify:cart:error' (detail.description = Shopify's sentence). Say it here, in French.
  document.addEventListener('shopify:cart:error', function (e) {
    var d = e.detail || {}, code = e.code || d.code, t = e.target && e.target.closest ? e.target : null;
    // v24: a quantity change in the cart page / drawer is not an add
    if (t && t.closest('cart-items-component')) {
      say(false, 'Panier non mis à jour', 'La quantité n’a pas pu être modifiée. Vérifiez votre connexion et réessayez.', null, function () { location.reload(); });
      return;
    }
    var pf = t && t.closest('product-form-component'), form = pf && pf.querySelector('form');
    var again = form ? function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } : null;
    var text = code === 'SERVICE_UNAVAILABLE' ? 'La connexion a été interrompue. Vérifiez votre réseau et réessayez.' : refusal({ description: d.description || '' }, code === 'INVALID' ? 422 : 0);
    say(false, 'Pas ajouté au panier', text, null, code === 'INVALID' ? null : again);
  });

  // fix (2026-10-16): Horizon's own adds announce 'shopify:cart:lines-update' before the request is sent, with
  // detail.promise settled once Shopify answered: then read /cart.js, paint the badges and tell the header
  // ('cart:update', as our own adds do) so every count follows the same path.
  document.addEventListener('shopify:cart:lines-update', function (e) {
    // v24: Horizon puts the promise on the event itself (e.promise), not in e.detail
    var p = e.promise || (e.detail && e.detail.promise), after = function () {
      fetch(CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCount(cart.item_count || 0);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'horizon', data: { source: 'horizon' } } }));
        }).catch(function () {});
    };
    if (p && typeof p.then === 'function') p.then(after, after); else setTimeout(after, 400);
  });

  // v24 (2026-10-17): the header's cart icon opens Horizon's cart drawer (theme-drawer#cart-drawer.open()). The older call in
  // assets/mj-header.js (cart-drawer-component.open) no longer exists in this Horizon version, so the icon always fell
  // back to the /cart page. On /cart (no drawer) or with a modifier key, the link works as a normal link.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mj-cart-link]') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var h = a.closest('[data-cart-drawer]'); if (h && h.getAttribute('data-cart-drawer') === 'false') return;
    var d = document.getElementById('cart-drawer');
    if (!d || typeof d.open !== 'function') return;
    e.preventDefault(); d.open();
  }, true);

  // v25: after Shopify confirmed an add: count, header, then the drawer (refreshed, then opened). If the drawer cannot be
  // refreshed, the toast says it instead; nothing is added a second time.
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function refreshDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d || typeof d.open !== 'function') return Promise.reject(new Error('no drawer'));
    // Horizon's renderer comes from the inline module in layout/theme.liquid (window.mjSectionRenderer): Shopify
    // minifies this file and would turn an import() here into a require() that browsers do not have
    return new Promise(function (resolve, reject) {
      if (window.mjSectionRenderer) return resolve(window.mjSectionRenderer);
      var t = setTimeout(function () { reject(new Error('no section renderer')); }, 4000);
      document.addEventListener('mj:sr-ready', function () { clearTimeout(t); resolve(window.mjSectionRenderer); }, { once: true });
    })
      .then(function (sr) { return sr.renderSection('cart-drawer-section', { cache: false, mode: 'hydration' }); })
      // an empty answer means another refresh of the drawer (Horizon reacts to 'cart:update' too) replaced this one:
      // the drawer is being refreshed either way, so it opens; only a real failure falls back to the toast
      .then(function () { return d; });
  }
  function afterAdd(title, img, productId) {
    return fetch(CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count || 0);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'mj-card', data: { source: 'mj-card', itemCount: 1, productId: productId } } }));
        return cart;
      }, function () { return null; })
      .then(function (cart) {
        return refreshDrawer().then(function (d) { hide(); d.open(); }, function () {
          say(true, 'Ajouté au panier', title, img);
          var addN = String(++adds); if (toast) toast.setAttribute('data-mj-add-n', addN);
          if (cart) shipLine(cart.total_price);
        });
      });
  }
  window.mjAfterAdd = afterAdd;

  // v25: the options window for products with options (colour, size…), opened by [data-mj-qs] (snippets/mj-qa)
  var qs = null, qsState = null;
  var BAG = '<svg class="mj-qa__ic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 8h14l-1.2 11.2a1.5 1.5 0 0 1-1.5 1.3H7.7a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 11.5v5M9.5 14h5"/></svg>';
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function qsMsg(t) { var m = qs && qs.querySelector('[data-qs-msg]'); if (m) { m.textContent = t || ''; m.hidden = !t; } }
  function qsBuild() {
    if (qs) return qs;
    qs = document.createElement('dialog');
    qs.className = 'mj-qs'; qs.setAttribute('aria-labelledby', 'mj-qs-t');
    qs.innerHTML = '<button type="button" class="mj-qs__x" data-qs-x aria-label="Fermer la fenêtre"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
      + '<div class="mj-qs__in"><div class="mj-qs__head"><div class="mj-qs__pic"><img alt="" data-qs-img></div><div class="mj-qs__hd">'
      + '<h2 class="mj-qs__h" id="mj-qs-t" data-qs-t></h2><p class="mj-qs__price" data-qs-price></p><a class="mj-qs__more" data-qs-more href="#">Voir la fiche du produit</a></div></div>'
      + '<div class="mj-qs__opts" data-qs-opts></div><p class="mj-qs__msg" data-qs-msg role="alert" hidden></p></div>'
      + '<div class="mj-qs__foot"><button type="button" class="mj-qa" data-qs-add><span class="mj-qa__t">' + BAG + '<span class="mj-qa__l">Ajouter au panier</span></span>'
      + '<span class="mj-qa__busy" aria-hidden="true"><i class="mj-qa__spin"></i>Ajout…</span><span class="mj-qa__ok" aria-hidden="true">Ajouté ✓</span><span class="mj-qa__err" aria-hidden="true">Non ajouté</span></button></div>';
    document.body.appendChild(qs);
    qs.querySelector('[data-qs-x]').addEventListener('click', function () { qs.close(); });
    // a click on the dimmed backdrop closes it
    qs.addEventListener('click', function (e) { if (e.target === qs) qs.close(); });
    qs.addEventListener('close', function () {
      var st = qsState; document.documentElement.classList.remove('mj-qs-lock'); qsState = null;
      // back to the button that opened it (Safari does not focus links on tap); after an add the drawer takes the focus
      if (st && !st.added && st.trigger && document.contains(st.trigger)) { try { st.trigger.focus({ preventScroll: true }); } catch (e) {} }
    });
    qs.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) qsSync(); });
    qs.querySelector('[data-qs-add]').addEventListener('click', qsAdd);
    return qs;
  }
  function qsSel() { var sel = []; qs.querySelectorAll('.mj-qs__f').forEach(function (fs, i) { var c = fs.querySelector('input:checked'); sel[i] = c ? c.value : null; }); return sel; }
  function qsFind(p, sel) {
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var k = 0; k < sel.length; k++) if ((v.options || [])[k] !== sel[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function imgUrl(u, w) { if (!u) return ''; u = typeof u === 'string' ? u : (u.src || ''); if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function qsSync() {
    var st = qsState; if (!st) return;
    var p = st.p, sel = qsSel(), v = qsFind(p, sel);
    st.v = v;
    qs.querySelectorAll('.mj-qs__f').forEach(function (fs, i) {
      var o = fs.querySelector('[data-qs-sel]'); if (o) o.textContent = sel[i] ? ' : ' + sel[i] : '';
      fs.querySelectorAll('.mj-qs__v').forEach(function (lab) {
        var val = lab.querySelector('input').value;
        var ok = p.variants.some(function (x) {
          return x.available && (x.options || []).every(function (y, k) { return k === i ? y === val : (sel[k] == null || y === sel[k]); });
        });
        lab.classList.toggle('is-na', !ok);
        var em = lab.querySelector('em'); if (em) em.hidden = ok;
      });
    });
    var img = qs.querySelector('[data-qs-img]'), src = imgUrl((v && v.featured_image) || p.featured_image, 240);
    if (src) { img.src = src; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
    var pr = v ? v.price : p.price, cmp = v ? v.compare_at_price : 0;
    qs.querySelector('[data-qs-price]').innerHTML = esc(money(pr)) + (cmp && cmp > pr ? ' <s><span class="mj-vh">Prix normal </span>' + esc(money(cmp)) + '</s>' : '');
    var add = qs.querySelector('[data-qs-add]');
    add.disabled = !(v && v.available);
    add.querySelector('.mj-qa__l').textContent = !v ? 'Combinaison indisponible' : (v.available ? 'Ajouter au panier' : 'Épuisé');
    add.setAttribute('aria-label', (!v ? 'Combinaison indisponible' : (v.available ? 'Ajouter au panier : ' : 'Épuisé : ') + p.title + (v.title && v.title !== 'Default Title' ? ' – ' + v.title : '')));
  }
  function qsShow(p, trigger, url) {
    qsBuild();
    qsState = { p: p, trigger: trigger, v: null, busy: false };
    qs.querySelector('[data-qs-t]').textContent = p.title;
    qs.querySelector('[data-qs-more]').href = url;
    var box = qs.querySelector('[data-qs-opts]'); box.innerHTML = '';
    var first = null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) { first = p.variants[i]; break; }
    (p.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name, values = (o && o.values) || [];
      if (!values.length) { var seen = {}; p.variants.forEach(function (v) { var x = (v.options || [])[i]; if (x != null && !seen[x]) { seen[x] = 1; values.push(x); } }); }
      var fs = document.createElement('fieldset'); fs.className = 'mj-qs__f';
      fs.innerHTML = '<legend>' + esc(name) + '<span class="mj-qs__sel" data-qs-sel></span></legend><div class="mj-qs__vals"></div>';
      var vals = fs.querySelector('.mj-qs__vals');
      values.forEach(function (val) {
        var lab = document.createElement('label'); lab.className = 'mj-qs__v';
        lab.innerHTML = '<input type="radio" name="mjqs' + i + '"><span>' + esc(val) + '<em class="mj-vh" hidden> (épuisé)</em></span>';
        var inp = lab.querySelector('input'); inp.value = val;
        if (first && (first.options || [])[i] === val) inp.checked = true;
        vals.appendChild(lab);
      });
      box.appendChild(fs);
    });
    qsMsg('');
    var add = qs.querySelector('[data-qs-add]'); add.classList.remove('is-busy', 'is-done', 'is-err'); add.removeAttribute('aria-busy');
    qsSync();
    document.documentElement.classList.add('mj-qs-lock');
    qs.showModal();
    var f = qs.querySelector('.mj-qs__opts input:checked') || qs.querySelector('.mj-qs__opts input') || add;
    if (f) f.focus();
  }
  function qsOpen(trigger) {
    if (trigger.__mjQsBusy) return;
    var handle = trigger.getAttribute('data-mj-qs'), url = trigger.getAttribute('href');
    trigger.__mjQsBusy = true; trigger.classList.add('is-busy'); trigger.setAttribute('aria-busy', 'true');
    function done() { trigger.__mjQsBusy = false; trigger.classList.remove('is-busy'); trigger.removeAttribute('aria-busy'); }
    fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) { done(); if (!p || !p.variants || !p.variants.length) throw new Error('no variants'); qsShow(p, trigger, url); })
      // the product data could not be read: the product page lets the customer choose instead
      .catch(function () { done(); if (url) location.href = url; });
  }
  function qsAdd() {
    var st = qsState; if (!st || st.busy || !st.v || !st.v.available) return;
    var add = qs.querySelector('[data-qs-add]'), v = st.v, answered = false;
    st.busy = true; add.classList.remove('is-err', 'is-done'); add.classList.add('is-busy'); add.setAttribute('aria-busy', 'true'); qsMsg('');
    function end() { answered = true; st.busy = false; add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); }
    function fail(t) { add.classList.add('is-err'); setTimeout(function () { add.classList.remove('is-err'); }, 2400); qsMsg(t); }
    fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        end();
        if (!res.ok) { fail(refusal(res.j, res.status)); return; }
        add.classList.add('is-done'); st.added = true;
        var trig = st.trigger, title = st.p.title + (v.title && v.title !== 'Default Title' ? ' – ' + v.title : '');
        setTimeout(function () {
          if (qs.open) qs.close();
          add.classList.remove('is-done');
          if (trig) { clearTimeout(trig.__mjT); trig.classList.add('is-done'); trig.__mjT = setTimeout(function () { trig.classList.remove('is-done'); }, 1600); }
          afterAdd(title, null, st.p.id);
        }, 650);
      })
      .catch(function () { if (answered) return; end(); fail('La connexion a été interrompue. Vérifiez votre réseau et réessayez.'); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mj-qs]') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (typeof HTMLDialogElement !== 'function') return; // very old browsers: the plain link to the product page
    e.preventDefault(); qsOpen(a);
  });

  function setCount(n) {
    document.querySelectorAll('[data-mj-cart-count]').forEach(function (b) {
      b.textContent = n; b.setAttribute('data-empty', n > 0 ? 'false' : 'true');
    });
  }
  window.mjSetCartCount = setCount;

  // v18: hover photos load on the first mouse visit of their card (fine pointers only; touch screens never load them)
  if (window.matchMedia && matchMedia('(hover: hover)').matches) document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.mj-card'), well = card && card.querySelector('.mj-card__well.has-alt');
    var hold = well && well.querySelector('source[data-mj-hold]'), img = well && well.querySelector('img.mj-card__alt');
    if (!hold || !img) return;
    img.addEventListener('load', function ready() {
      if ((img.currentSrc || '').indexOf('data:') === 0) return;
      img.removeEventListener('load', ready); well.classList.add('is-alt');
      img.__mjLook = false; if (window.mjLookPhotos) window.mjLookPhotos(well);
    });
    hold.remove();
  }, { passive: true });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-mj-add]')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]') || form.querySelector('button');
    if (form.__mjBusy) return; form.__mjBusy = true;
    // v17 home: one state at a time (busy, then done or error for a moment)
    function mark(cls, ms) {
      if (!btn) return;
      clearTimeout(btn.__mjT); btn.classList.remove('is-done', 'is-err');
      if (!cls) return;
      btn.classList.add(cls); btn.__mjT = setTimeout(function () { btn.classList.remove(cls); }, ms);
    }
    if (btn) { mark(null); btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    var card = form.closest('[data-mj-card], .mj-card, .lh-arr__card, .lh-pick, .lp-more__card');
    var tEl = card && card.querySelector('.mj-card__title, [data-mj-product-title], .lh-arr__t b, .lh-pick__t b, .lp-more__t');
    var img = card && card.querySelector('.mj-card__well img.mj-card__main, .mj-card__well img, [data-mj-photo] img, img');
    var answered = false;
    function again() { if (form.requestSubmit) form.requestSubmit(btn && btn.form === form ? btn : undefined); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
    function end() { answered = true; form.__mjBusy = false; if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } }
    fetch(ADD, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        end();
        if (!res.ok) {
          mark('is-err', 2400);
          // a refusal for stock (422) cannot succeed by trying again; any other answer can
          say(false, 'Pas ajouté au panier', refusal(res.j, res.status), null, res.status === 422 ? null : again);
          return;
        }
        mark('is-done', 1600);
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        var title = (tEl && (function (c) { [].forEach.call(c.querySelectorAll('.mj-vh'), function (n) { n.remove(); }); return c.textContent.trim(); })(tEl.cloneNode(true))) || (item && (item.product_title || item.title)) || '';
        // v25: count + drawer (refreshed and opened); the toast only when the drawer is missing or cannot be refreshed
        return afterAdd(title, img, item && item.product_id).catch(function () {});
      })
      // v24: no answer at all (network down): a French message and a retry, nothing added, nothing counted
      .catch(function () {
        if (answered) return; end(); mark('is-err', 2400);
        say(false, 'Pas ajouté au panier', 'La connexion a été interrompue. Vérifiez votre réseau et réessayez.', null, again);
      });
  });
})();
